import React from 'react';

export default ({ title = '' }) => ( <h3>{title}</h3> );
